import { render, staticRenderFns } from "./GuestButtonsBar.vue?vue&type=template&id=127f83e4"
import script from "./GuestButtonsBar.vue?vue&type=script&lang=js"
export * from "./GuestButtonsBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports